export enum FormFactor {
  Desktop = "DSK",
  Tablet = "TAB",
  Mobile = "MOB",
}
